import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, __experimentalUnitControl as UnitControl, RangeControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';
export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        menuItemNum,
        megaMenuInnerWidth,
        megaMenuBGcolor,
        megaMenuPadding,
        megaMenuLinkCurrentColor,
        megaMenuLinksHoverColor,
        megaMenuDetailsColor,
        megaMenuDetailsHoverColor,
        megaMenuDropdownColor,
        megaMenuDropdownHoverColor,
        megaMenuBorderColor,
        megaMenuIconBgColor,
        megaMenuIconSize,
        megaMenuLabelSize,
        megaMenuItemPadding,
        megaMenuContentGap,
        mageMenuListItemGap,
        megaMenuListBorderRadius,
        megaMenuIconColor,
        megaMenuIconHoverColor,
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: 'hfcmm-' + clientIdSliced });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();

    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'hfc-blocks/icon-list',
        'hfc-blocks/list-item',
        'core/media-text',
        'core/image',
        'core/heading',
        'core/paragraph'
    ];

    const TEMPLATE = [['core/group', {
        className: 'hfc-mm-2'
    }, [
        ['core/columns', {
            verticalAlignment: 'center',
            className: 'hfc-mm-cols'
        }, [
              [
                "core/column",
                {
                  width: "33.33%",
                  className: "hfc-mm-col",
                },
                [
                  [
                    "hfc-blocks/icon-list",
                    {},
                    [
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Info Articles Automation</strong><br>Use AI to create interesting and captivating blog articles effortlessly.",
                              icon: "faNewspaper",
                              isLinkable: true
                            },
                        ],
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Food Recipe Article</strong><br>Make tasty, quick, and easy-to-follow family recipes using AI.",
                              icon: "faCheese",
                              isLinkable: true
                            },
                        ],
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Mobile Spcs Article</strong><br>Write detailed mobile phone specifications with AI.",
                              icon:"faMobileScreen",
                              isLinkable: true
                            },
                        ],
                    ],
                  ],
                ],
              ],
              [
                "core/column",
                {
                  width: "33.33%",
                  className: "hfc-mm-col",
                },
                [
                  [
                    "hfc-blocks/icon-list",
                    {},
                    [
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Amazon Review Article</strong><br>Write detailed and insightful Amazon reviews with the help of AI.",
                              icon: "faAmazon",
                              isLinkable: true
                            },
                        ],
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>SaaS Review Article</strong><br>Write clear and detailed expert reviews of SaaS products with AI.",
                              icon: "faCloudversify",
                              isLinkable: true
                            },
                        ],
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Automation (Advanced)</strong><br>Use an advanced model to make your content creation process.",
                              icon: "faRobot",
                              isLinkable: true
                            },
                        ],
                    ],
                  ],
                ],
              ],
              [
                "core/column",
                {
                  width: "33.33%",
                  className: "hfc-mm-col",
                },
                [
                  [
                    "hfc-blocks/icon-list",
                    {},
                    [
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Write Versus Article</strong><br>Compare two things and see their differences with AI's.",
                              icon: "faBlog",
                              isLinkable: true
                            },
                        ],
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Biography Article</strong><br>Create well-researched and captivating life biographies with AI.",
                              icon: "faBookAtlas",
                              isLinkable: true
                            },
                        ],
                        [
                            "hfc-blocks/list-item",
                            {
                              spanText: "<strong>Upcoming Soon</strong><br>Wait a few more days patiently for an important new update here.",
                              icon: "faUpLong",
                              isLinkable: true
                            },
                        ],
                    ],
                  ],
                ],
              ],
        ]],
    ]]];

    const hfcmmDynamicStyles = `#${id}.hfc-mega-menu .hfc-mm-2{
        background-color: ${megaMenuBGcolor};
        padding: ${megaMenuPadding}px;
        border-radius: 10px;
        box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
        border-top: 5px solid ${megaMenuBorderColor};
        width: ${megaMenuInnerWidth};
        margin: 0px auto!important;
    }
   .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
    #${id}.hfc-mega-menu .hfc-mm-2 .wp-block-group__inner-container{
        padding: 0px;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main{
        margin-top: 0;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .fp-ip-inner{
       padding: 10px;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item{
       border-radius: ${megaMenuListBorderRadius}px;
       transition: 0.4s;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover{
       box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item span{
        line-height: 20px;
        font-size: calc(${megaMenuLabelSize}px - 3px);
        color: ${megaMenuDetailsColor};
        font-weight: normal;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover span{
        color: ${megaMenuDetailsHoverColor};
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item .fp-ip-icon{
        background-color: ${megaMenuIconBgColor}!important;
        padding: ${megaMenuItemPadding}!important;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item strong{
        font-size: ${megaMenuLabelSize}px;
        color: ${megaMenuLinkCurrentColor};
        transition: 0.4s;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover strong{
        color: ${megaMenuLinksHoverColor};
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .block-editor-inner-blocks > .block-editor-block-list__layout{
        gap:${mageMenuListItemGap}px!important;
    }
    .editor-styles-wrapper #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item svg{
        height: ${megaMenuIconSize}px!important;
        width: ${megaMenuIconSize}px!important;
        color: ${megaMenuIconColor}!important;
    }
    .editor-styles-wrapper #${id} .hfc-mm-cols{
        margin-top: 0px;
    }
    .editor-styles-wrapper #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover svg{
       color: ${megaMenuIconHoverColor}!important;
    }
    .editor-styles-wrapper #${id} .hfc-mm-2 .fp-ip-inner{
        gap: ${megaMenuContentGap}px;
    }
    /* Edit Page Compatibility */
    .editor-styles-wrapper .wp-block-hfc-blocks-mega-menu-2{
        max-width: 1200px!important;
    }
    .editor-styles-wrapper .wp-block{
        margin: 0px auto;
        max-width: 1200px!important;
    }
    .editor-styles-wrapper .hfc-mm-2 .wp-block-group__inner-container{
       max-width: 100%!important;
    }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Mega Menu-02 Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
                >
                <NumberControl
                    label={__('Menu Item Number')}
                    isShiftStepEnabled={ true }
                    onChange={newValue => setAttributes({ menuItemNum: newValue })}
                    shiftStep={ 1 }
                    value={ menuItemNum }
                    />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Padding (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuPadding: newValue })}
                    isDragEnabled
                    value={megaMenuPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Icon Size (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuIconSize: newValue })}
                    isDragEnabled
                    value={megaMenuIconSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Icon Background Size :')}
                    onChange={newValue => setAttributes({megaMenuItemPadding: newValue })}
                    isUnitSelectTabbable
                    value={megaMenuItemPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu List Item Size (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuLabelSize: newValue })}
                    isDragEnabled
                    value={megaMenuLabelSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Content Gap (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuContentGap: newValue })}
                    isDragEnabled
                    value={megaMenuContentGap}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu List Items Gap (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({mageMenuListItemGap: newValue })}
                    isDragEnabled
                    value={mageMenuListItemGap}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>List Item Border Radius (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({megaMenuListBorderRadius: newValue })}
                    isDragEnabled
                    value={megaMenuListBorderRadius}
                    className={'frhd__component frhd__component-width-90'}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Background Color :</Heading>
                <ColorPalette
                    value={megaMenuBGcolor}
                    onChange={(colorValue) => setAttributes({ megaMenuBGcolor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Icon Background Color :</Heading>
                <ColorPalette
                    value={megaMenuIconBgColor}
                    onChange={(colorValue) => setAttributes({ megaMenuIconBgColor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Heading Color :</Heading>
                <ColorPalette
                    value={megaMenuLinkCurrentColor}
                    onChange={(colorValue) => setAttributes({ megaMenuLinkCurrentColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Heading Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ megaMenuLinksHoverColor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Item Details Color :</Heading>
                <ColorPalette
                    value={megaMenuDetailsColor}
                    onChange={(colorValue) => setAttributes({ megaMenuDetailsColor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Item Details Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuDetailsHoverColor}
                    onChange={(colorValue) => setAttributes({ megaMenuDetailsHoverColor: colorValue })}
                    clearable={false}
                />
                    <Heading className={"frhd__pb-heading"}>Dropdown Color :</Heading>
                <ColorPalette
                    value={megaMenuDropdownColor}
                    onChange={(colorValue) =>
                    setAttributes({megaMenuDropdownColor: colorValue })
                    }
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Dropdown Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuDropdownHoverColor}
                    onChange={(colorValue) => setAttributes({ megaMenuDropdownHoverColor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Border Color :</Heading>
                <ColorPalette
                    value={megaMenuBorderColor}
                    onChange={(colorValue) => setAttributes({ megaMenuBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Icon Color :</Heading>
                <ColorPalette
                    value={megaMenuIconColor}
                    onChange={(colorValue) => setAttributes({megaMenuIconColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Icon Hover Color  :</Heading>
                <ColorPalette
                    value={megaMenuIconHoverColor}
                    onChange={(colorValue) => setAttributes({megaMenuIconHoverColor: colorValue })}
                    clearable={false}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-mega-menu'}>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                    />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        menuItemNum,
        megaMenuInnerWidth,
        megaMenuBGcolor,
        megaMenuPadding,
        megaMenuLinkCurrentColor,
        megaMenuLinksHoverColor,
        megaMenuDetailsColor,
        megaMenuDetailsHoverColor,
        megaMenuDropdownColor,
        megaMenuDropdownHoverColor,
        megaMenuBorderColor,
        megaMenuIconBgColor,
        megaMenuIconSize,
        megaMenuLabelSize,
        megaMenuItemPadding,
        megaMenuContentGap,
        mageMenuListItemGap,
        megaMenuListBorderRadius,
        megaMenuIconColor,
        megaMenuIconHoverColor
    } = attributes;

    const hfcmmDynamicStyles = `#${id}.hfc-mega-menu {
        display: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
        top: 25px;
    }
    .hfc-main-header-2 #${id}.hfc-mega-menu{
        left: unset !important;
        transform: unset !important;
        right: 0;
        top: 50% !important;
    }
    #${id}.hfc-mega-menu .hfc-mm-2{
        background-color: ${megaMenuBGcolor};
        padding: ${megaMenuPadding}px;
        border-radius: 10px;
        box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
        border-top: 5px solid ${megaMenuBorderColor};
        margin-top: 25px;
        width: ${megaMenuInnerWidth};
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style:solid;
        border-color:${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
    #${id}.hfc-mega-menu .hfc-mm-2 .wp-block-group__inner-container{
        padding: 0px;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main{
        margin-top: 0;
        gap:${mageMenuListItemGap}px!important;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .fp-ip-inner{
       padding: 10px;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item{
       border-radius: ${megaMenuListBorderRadius}px;
       transition: 0.4s;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover{
       box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item span{
        line-height: 20px;
        font-size: calc(${megaMenuLabelSize}px - 3px);
        color: ${megaMenuDetailsColor}!important;
        font-weight: normal;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover span{
        color: ${megaMenuDetailsHoverColor}!important;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item .fp-ip-icon{
        background-color: ${megaMenuIconBgColor}!important;
        padding: ${megaMenuItemPadding}!important;
    }
     #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item strong{
        font-size: ${megaMenuLabelSize}px;
        color: ${megaMenuLinkCurrentColor};
        transition: 0.4s;
    }
     #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover strong{
        color: ${megaMenuLinksHoverColor};
    }
     #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item svg{
        height: ${megaMenuIconSize}px!important;
        width: ${megaMenuIconSize}px!important;
        color: ${megaMenuIconColor}!important;
    }
    #${id} .hfc-mm-2 .hfc-icon-list-main .wp-block-hfc-blocks-list-item:hover svg{
        color: ${megaMenuIconHoverColor}!important;
    }
     #${id} .hfc-mm-2 .hfc-icon-list-main .fp-ip-inner{
        gap: ${megaMenuContentGap}px;
     }
    @media (max-width: 599px){
         #${id} .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu a::after,
         #${id} .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu a::after,
         #${id} .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu a::after{
            display: none;
        }
    }`;

    return (
        <>
            <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
            <div id={id} data-menu-item-number={menuItemNum} className={'hfc-mega-menu'}>
                <InnerBlocks.Content />
            </div>
        </>
    )
}